import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { getMessageSanitizationChannel } from 'app/utils/htmlSanitizer';
import { Message } from '../../../conversation/components/message';
import { getAuthorName, LogEntry } from './logEntry';
import styles from './logEntry/logEntry.module.scss';
import { UserLink } from './userLink/userLink';
export const MessageAdded = ({ entry, messages, }) => {
    const authorName = getAuthorName(entry);
    const authorLink = _jsx(UserLink, Object.assign({ userId: entry.author.id }, { children: authorName }));
    const userType = entry.activity_type === 'MESSAGE_ADDED_BY_AGENT' ? 'agent' : 'customer';
    const text = (_jsxs(_Fragment, { children: ["Message is added by ", userType, " ", authorLink] }));
    const author = Object.assign(Object.assign({}, entry.author), { avatar_url: entry.author_avatar_url, roles: [] });
    const message = messages.find((message) => message.id === entry.message_id);
    return (_jsx(LogEntry, Object.assign({ entry: entry, text: text }, { children: (message === null || message === void 0 ? void 0 : message.text) ? (_jsx(Message, { className: styles.message, author: author, markup: message.text, date: "", channel: getMessageSanitizationChannel(message) })) : null })));
};
